import { MultipleChart } from "components";
import { DashboardFillType } from "types";
import { useList } from "../../utils";
import { convertNumber } from "utils";

export function ValueStockSection(props: {
    fill: DashboardFillType
}) {

    const { data } = useList({
		date: `${props.fill.year}${props.fill.month}`,
		location_id: props.fill.location_id?.toString() || ""
	})

    const balanceData = data?.valueStock?.data_balance || []

    const isEmptyPie = balanceData.length === 0 || balanceData.every(item => Number(item.balance || 0) === 0);

    return (
        // <section className="flex flex-col  p-3 items-center">
            <div className="justify-center border min-h-[450px]">
                <div className="text-center text-lg font-bold mb-3">
                    Value Stock On Hand Per Location <br />
                    <span className="text-sm">Total Balance : {convertNumber(Number(data?.valueStock?.total_balance ?? 0)).intoCurrency}</span>
                </div>
                <div className="flex justify-center items-center h-[400px] w-full">
                    {isEmptyPie ? (
                        <div className="w-full max-w-[360px] aspect-square rounded-full bg-gray-300 flex items-center justify-center">
                            <span className="text-gray-500 text-sm">No Data</span>
                        </div>
                    ) : (
                        <MultipleChart
                            chartType="pie"
                            className="h-[90%] w-[90%]"
                            data={{
                                labels: balanceData.map(item => item.location_name),
                                datasets: [
                                {
                                    data: balanceData.map(item => item.balance_per_total * 100),
                                },
                                ],
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false, 
                                plugins: {
                                legend: { position: "bottom" },
                                tooltip: {
                                    callbacks: {
                                    label: function (context) {
                                        const item = balanceData[context.dataIndex];
                                        if (!item) return "";
                                        return `${item.location_name}: ${item.balance.toLocaleString()}`;
                                    },
                                    },
                                },
                                datalabels: {
                                    formatter: value => value + "%",
                                },
                                },
                            }}
                        />
                    )}
                </div>
            </div>
        // </section>
    )
}